import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.tsx'
import './index.css'

import WebApp from '@twa-dev/sdk'
import {BrowserRouter, Route, Routes} from "react-router-dom";
import Film from "./pages/Film";

// Telegram WebApp detection:
// - In real Telegram WebApp: initDataUnsafe contains data from Telegram
// - In normal browser (even with SDK loaded): initDataUnsafe is empty
const isTelegramWebApp =
    typeof window !== 'undefined' &&
    !!(window as any).Telegram &&
    !!(window as any).Telegram.WebApp &&
    !!WebApp.initDataUnsafe &&
    Object.keys(WebApp.initDataUnsafe).length > 0;

if (!isTelegramWebApp) {
    window.location.href = 'https://t.me/filmidea_bot';
} else {
    WebApp.ready();

    ReactDOM.createRoot(document.getElementById('root')!).render(
        <React.StrictMode>
            <BrowserRouter>
                <Routes>
                    <Route path={'/'} index element={<App/>} />
                    <Route path={`/film/:id`} index element={<Film/>} />
                </Routes>
            </BrowserRouter>
        </React.StrictMode>,
    )
}
